import { LayoutPropTypes } from '../components/layout/LayoutPropTypes';

export const ROUTE_CONSTANTS: Record<string, LayoutPropTypes> = {
   home: {
      path: '/reverification',
      pageName: 'SKYC_LANDING_PAGE',
      showHeader: true,
      showFooter: false,
   },
   thankyou: {
      path: '/reverification/thank-you',
      pageName: 'SKYC_THANK_YOU',
      showHeader: true,
      showFooter: false,
   },
   newSkycUserDetails: {
      path: '/details',
      pageName: 'NEW_ACQ_POSTPAID_SKYC_LANDING_PAGE',
      showHeader: true,
      showFooter: false,
   },
   newSkycPrepaidDetails: {
      path: '/prepaid-sim', 
      pageName: 'NEW_ACQ_POSTPAID_SKYC_LANDING_PAGE',
      showHeader: true,
      showFooter: false,
      layoutName: 'prepaid_sim'
   },
   newSkycPrepaidDetailsNewRoute: {
      path: '/buy-new-sim', 
      pageName: 'NEW_ACQ_POSTPAID_SKYC_LANDING_PAGE',
      showHeader: true,
      showFooter: false,
      layoutName: 'prepaid_sim'
   },
   newSkycCocpDetails: {
      path: '/cocp-sim', 
      pageName: 'NEW_ACQ_POSTPAID_SKYC_LANDING_PAGE',
      showHeader: true,
      showFooter: false,
      layoutName: 'cocp_to_retail'
   },
   newSkyc: {
      path: '/verification',
      pageName: 'NEW_ACQ_POSTPAID_SKYC',
      showHeader: true,
      showFooter: false,
   },
   newSkycRevamp: {
      path: '/verify',
      pageName: 'SKYC_REVAMP_KYC_LANDING_PAGE',
      showHeader: true,
      showFooter: false,
   },
   newSkycVerifyAadhaar: {
      path: '/aadhaar',
      pageName: 'NEW_ACQ_SKYC_VERIFY_AADHAAR',
      showHeader: true,
      showFooter: false,
   },
   newSkycLocalReference: {
      path: '/local-reference',
      pageName: 'NEW_ACQ_SKYC_LOCAL_REFERENCE',
      showHeader: true,
      showFooter: false,
   },
   newSkycSelfie: {
      path: '/selfie',
      pageName: 'NEW_ACQ_SKYC_SELFIE',
      showHeader: true,
      showFooter: false,
   },
   newSkycDisability: {
      path: '/disability',
      pageName: 'NEW_ACQ_SKYC_DISABILITY',
      showHeader: true,
      showFooter: false,
   },
   newSkycLoader: {
      path: '/loader',
      pageName: 'NEW_ACQ_POSTPAID_SKYC_LOADER_PAGE',
      showHeader: true,
      showFooter: false,
   },
   orderSummary: {
      path: '/order-summary',
      pageName: 'NEW_ACQ_POSTPAID_SKYC_ORDER_SUMMARY_PAGE',
      showHeader: true,
      showFooter: false,
   },
   newSkycThankYou: {
      path: '/thank-you',
      pageName: 'NEW_ACQ_POSTPAID_SKYC_THANK_YOU',
      showHeader: true,
      showFooter: false,
   },
   prereadPage: {
      path: '/',
      pageName: 'NEW_ACQ_SKYC_PREREAD_PAGE',
      showHeader: true,
      showFooter: false,
   },
   prepaidSkycThankYou: {
      path: '/prepaid/thank-you',
      pageName: 'NEW_ACQ_PREPAID_SKYC_SUCCESS_PAGE',
      showHeader: true,
      showFooter: false,
   },
   simActivationPage: {
      path: '/sim-activation',
      pageName: 'SIM_ACTIVATION_PAGE',
      showHeader: true,
      showFooter: false,
   },
   simActivationThankyouPage: {
      path: '/sim-activation/thank-you',
      pageName: 'SIM_ACTIVATION_THANKYOU_PAGE',
      showHeader: true,
      showFooter: false,
   },
   skycRevampLandingPage: {
      path: '/new-sim',
      pageName: 'SKYC_REVAMP_LANDING_PAGE',
      showHeader: true,
      showFooter: false,
   },
   skycSelectConnectionPage: {
      path: '/select-connection',
      pageName: 'SKYC_REVAMP_SELECTCONNECTION_PAGE',
      showHeader: true,
      showFooter: false,
   },
   skycChooseSIMtype: {
      path: '/choose-sim-type',
      pageName: 'SKYC_REVAMP_CHOOSE_SIM_TYPE',
      showHeader: true,
      showFooter: false,
   },
   skycPlanPage: {
      path: '/plan',
      pageName: 'SKYC_REVAMP_PLAN_PAGE',
      showHeader: true,
      showFooter: false,
   },
   skycReviewPage: {
      path: '/review',
      pageName: 'SKYC_REVAMP_REVIEW_PAGE',
      showHeader: true,
      showFooter: false,
   },
};

export const PAGESPACE_PAGES = Object.values(ROUTE_CONSTANTS).map(route => ({
   pageName: route.pageName,
   layoutName: route.layoutName
}));

export const BASE_HREF = '/kyc';
export const IS_PRODUCTION = window?.location?.origin?.includes('www.airtel.in');
export const IS_LOCAL = process.env.NODE_ENV === 'development';
